module.exports = __webpack_public_path__ + "img/17.0d1ab3d0.png";